import React from 'react';

/** Grab width of a resize strip. Wide enough to hit, narrow enough not to swallow the body drag. */
const HANDLE_WIDTH = 8;

interface Props {
  /** Distance from the block's left edge, in px. */
  leftPx: number;
  onPointerDown: (e: React.PointerEvent) => void;
  /** Hovering announces which segment this strip is about to resize. */
  onHoverChange: (hovered: boolean) => void;
  label: string;
}

/** The invisible grab strip sitting on a block boundary a resize drag moves. */
export const HandleStrip = ({ leftPx, onPointerDown, onHoverChange, label }: Props) => (
  <div
    role="separator"
    aria-label={label}
    // Stops the body-move handler underneath from also firing.
    onPointerDown={(e) => {
      e.stopPropagation();
      onPointerDown(e);
    }}
    onClick={(e) => e.stopPropagation()}
    onPointerEnter={() => onHoverChange(true)}
    onPointerLeave={() => onHoverChange(false)}
    className="absolute bottom-0 top-0 z-10 cursor-ew-resize hover:bg-white/40"
    style={{ left: leftPx - HANDLE_WIDTH / 2, width: HANDLE_WIDTH }}
  />
);
